export const isValidLat = (lat: number) => {
  return !isNaN(lat) && lat >= -90 && lat <= 90;
}

export const isValidLong = (long: number) => {
  return !isNaN(long) && long >= -180 && long <= 180;
}